import { Grid, Skeleton } from "@mui/material";

export default function FooterExternalSkeleton() {
  return (
    <Grid item container direction="row" spacing={2} px="20vw" py="10px" marginTop={0} justifyContent="space-between" alignItems="center"
      style={{
        paddingInline: "20vw",
        paddingBlock: "10px",
        backgroundColor: "#f1f3f4",
        borderTop: "1px solid #E7E7E7",
        textAlign: "center",
      }}>
      <Grid container item sm={9} spacing={2} direction="column">
        <Grid item textAlign='start'>
          <Skeleton variant="rectangular" width={250} height={60} />
        </Grid>
        <Grid container item sm={6} spacing={4} direction="row">
          <Grid item pt={0}>
            <Skeleton variant="text" width={120} height={24} />
          </Grid>
          <Grid item pt={0}>
            <Skeleton variant="text" width={100} height={24} />
          </Grid>
          <Grid item pt={0}>
            <Skeleton variant="text" width={150} height={24} />
          </Grid>
        </Grid>
      </Grid>
      <Grid container item sm={2} direction="row" justifyContent="end" spacing={2}>
        <Grid item sm={3}>
          <Skeleton variant="circular" width={32} height={32} />
        </Grid>
        <Grid item sm={3}>
          <Skeleton variant="circular" width={32} height={32} />
        </Grid>
        <Grid item sm={3}>
          <Skeleton variant="circular" width={32} height={32} />
        </Grid>
      </Grid>
    </Grid>
  );
}